import { Close } from '@browsing/icons';
import { FunctionColor, TextFontSize, mediaMinWidth } from '@lux/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ sticky: boolean; inline: boolean }>`
    width: 100%;
    position: relative;
    display: flex;
    background-color: ${FunctionColor.function0};
    color: ${FunctionColor.function100};
    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 5px 0;
    opacity: 0.9;
    z-index: 99;

    ${({ sticky }) =>
        sticky &&
        css`
            bottom: 0;
            position: fixed;
            padding: 0 3%;

            ${mediaMinWidth.md} {
                width: 100%;
                padding: 0 10%;
            }
        `}

    ${({ inline }) =>
        inline &&
        css`
            box-shadow: none;
            background-color: ${FunctionColor.function0};
            height: 120px;

            ${mediaMinWidth.sm} {
                height: 156px;
            }
        `}
`;

export const CloseIconWrapper = styled.button`
    position: absolute;
    right: 8px;
    top: 4px;
    padding: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: ${FunctionColor.function100};
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        }

        &:focus-visible {
            outline: 2px solid currentColor;
            outline-offset: 2px;
            border-radius: 4px;
            border-bottom: none;
        }
    }
`;

export const CloseIcon = styled(Close)`
    color: ${FunctionColor.function100};
    transition: 200ms color ease-in-out;

    ${CloseIconWrapper} {
        &:hover {
            color: #898989;
        }
    }
`;
export const WrapperInner = styled.div`
    width: 100%;
    position: relative;
    display: flex;
`;
export const IconSection = styled.div<{ inline: boolean }>`
    display: flex;
    align-items: ${({ inline }) => (inline ? 'center' : 'flex-start')};
    justify-content: center;
    padding: 15px 0;
    width: 50px;
    flex-grow: 0;
    flex-shrink: 0;

    ${mediaMinWidth.sm} {
        width: 100px;
        align-items: center;
    }

    svg {
        width: 30px;
        height: 30px;
        ${mediaMinWidth.sm} {
            width: 40px;
            height: 40px;
        }
    }
`;
export const ContentSection = styled.div<{ sticky: boolean; inline: boolean }>`
    display: inline-block;
    padding: 10px 35px 10px 0;
    font-size: ${TextFontSize.XS};
    ${mediaMinWidth.sm} {
        padding: 20px 50px 20px 0;
        font-size: ${TextFontSize.S};
    }

    ${({ sticky }) =>
        sticky &&
        css`
            padding: 20px 0;
        `}

    ${({ inline }) =>
        inline &&
        css`
            display: flex;
            justify-content: center;
            flex-direction: column;
        `}
`;

export const Content = styled.div`
    padding-top: 5px;
`;

export const LoaderWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const Loader = styled.div`
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    text-align: center;
    width: 100%;
`;
